module.exports = __webpack_public_path__ + "static/media/8.c1d528db.svg";